import { CCUtils } from "../../../../common/CCUtils"
import { Scale } from "../../../utils/Scale"
import { Sprites } from "../../../utils/Sprites"
import { MakeVideoAtlases } from "../MakeVideoAssets"

export class MakeVideoStepsContainer {

    private currentStep: Phaser.Sprite
    private stepDisplay: Phaser.Sprite
    private current: number

    constructor(game: Phaser.Game) {
        this.currentStep = Sprites.add(game, MakeVideoAtlases.CURRENT_STEP, {
            debug: CCUtils.debug,
            x: Scale.x(0.007),
            y: Scale.y(0.095)
        })
        this.stepDisplay = Sprites.add(game, MakeVideoAtlases.STEP_DISPLAY, {
            debug: CCUtils.debug,
            x: Scale.x(0.593),
            y: Scale.y(0.03)
        })
        this.current = 0
    }

    get step(): number {
        return this.current
    }

    set step(s: number) {
        if (s >= 0 && s < 5) {
            this.current = s
            this.setCurrentStep(s)
        }
    }

    private setCurrentStep = (step: number) => {
        if (step === 4) {
            this.currentStep.frame = 6
        } else {
            this.currentStep.frame = step
        }

        if (step === 2 || step === 3) {
            this.stepDisplay.frame = 2
        } else if (step === 4) {
            this.stepDisplay.frame = 3
        } else {
            this.stepDisplay.frame = step
        }
    }

}